import React from 'react';
import { Link } from 'gatsby';
import image from './img/bathroom-discount.png';

// Helper function to calculate the last day of the current month
const getLastDayOfCurrentMonth = () => {
	const now = new Date();
	const lastDay = new Date(now.getFullYear(), now.getMonth() + 1, 0);
	return lastDay.toLocaleDateString('en-US', {
		month: 'long',
		day: 'numeric',
		year: 'numeric'
	});
};

const TanklessWaterHeaterPromotion = () => (
	<div
		className={`rounded-lg mb-2 shadow-lg overflow-hidden`}
		style={{
			background: 'linear-gradient(135deg, #2D5A3D 0%, #1E3A2A 100%)'
		}}
	>
		<div className="px-6 py-6 text-center">
			<div className="mb-4">
				<span 
					className="inline-block text-white text-sm font-semibold px-3 py-1 rounded-full mb-3"
					style={{ backgroundColor: '#4A7C59' }}
				>
					 Special Offer 
				</span>
				<h2 className="text-white font-bold text-4xl md:text-5xl mb-2 leading-tight">
					<span className="relative inline-block" style={{ color: '#F5A623' }}>
						$1500
						<svg 
							className="absolute left-0 w-full"
							style={{ 
								bottom: '-8px',
								height: '12px'
							}}
							viewBox="0 0 100 12"
							preserveAspectRatio="none"
						>
							<path 
								d="M2,8 Q30,4 50,6 Q70,8 98,5" 
								stroke="#F5A623" 
								strokeWidth="3" 
								fill="none"
								strokeLinecap="round"
								opacity="0.9"
							/>
							<path 
								d="M3,9 Q32,5 51,7 Q71,9 97,6" 
								stroke="#F5A623" 
								strokeWidth="2" 
								fill="none"
								strokeLinecap="round"
								opacity="0.6"
							/>
						</svg>
					</span> OFF
				</h2>
				<p className="text-white text-lg md:text-xl font-medium mb-6 leading-relaxed">
					Your Dream Kitchen or <br />
					Bathroom Transformation
				</p>
			</div>
			
			<Link
				to={'/offers/bathroom-kitchen-remodel-special-offer/'}
				className="inline-block font-bold text-lg cursor-pointer transition duration-200 ease-in-out text-brand-primary hover:text-white focus:outline-none px-8 py-4 rounded-full shadow-lg transform hover:scale-105 font-display"
				style={{ 
					backgroundColor: '#ffffff',
					color: 'black'
				}}
				onMouseEnter={(e) => {
					e.target.style.backgroundColor = '#F5A623';
				}}
				onMouseLeave={(e) => {
					e.target.style.backgroundColor = 'white';
				}}
			>
				Claim Your Discount →
			</Link>
			
			<div className="mt-6 pt-4 border-t border-white border-opacity-20">
				<p className="text-white text-sm opacity-90">
					*Offer expires {getLastDayOfCurrentMonth()}
				</p>
			</div>
		</div>

		<div className="px-6 pb-4">
			<div className="bg-white bg-opacity-10 rounded-lg p-3">
				<img 
					src={image} 
					alt="Kirkland Kitchen and Bath Remodeling" 
					className="w-full h-auto rounded"
				/>
			</div>
		</div>
	</div>
);

export default TanklessWaterHeaterPromotion;
